import React from "react";
import styled from "styled-components";
import TailSpin from "./Loader";

const Spinner = ({ width = 75, height = 75, fill = "#00197b" }) => {
  const SpinnerContainer = styled.div`
    overflow: hidden;
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
  `;

  return (
    <SpinnerContainer>
      <TailSpin width={width} height={height} fill={fill} />
    </SpinnerContainer>
  );
};

export default Spinner;
